/**
 * When OutletSelector may validate the saved station - PS-10499.
 *
 * Kept out of the .vue so tests/jest (no Vue tooling) can cover it. The rule:
 * never validate against a list that has not loaded yet, or every saved
 * station looks invalid and resets to All Stations.
 */

/** Whether a region or trading-area filter is set. */
export function hasAreaFilters(areaFilters) {
    return (
        !!areaFilters &&
        (areaFilters.region_ids.length > 0 ||
            areaFilters.trading_area_ids.length > 0)
    );
}

/** Skip on load when area filters are set: filteredOutlets is still loading. */
export function shouldValidateOnLoad(areaFilters) {
    return !hasAreaFilters(areaFilters);
}

/** Only when area filters are cleared (PS-4765), never on the first run. */
export function shouldValidateOnFilterChange(previous, current) {
    return hasAreaFilters(previous) && !hasAreaFilters(current);
}

/** Whether the station is still an option. 0 is All Stations. */
export function isSelectionValid(outletId, outlets) {
    return outletId === 0 || outlets.some(o => o.id === outletId);
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/outlet-selector-rules.js